var _rect, _line, _line2, _line3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#FFCD00",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#FFCD00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "windowIconTitle"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    x1: 6,
    y1: 6,
    x2: 6,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    x1: 9,
    y1: 6,
    x2: 9,
    y2: 6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,9 L3,9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.015ab8284a34b008afe54346de9ae14e.svg";
export { ForwardRef as ReactComponent };